(() => {
  const formatPolicyContent = () => {
    if (!document.body.classList.contains('ccf-template-policy')) return;

    const title = document.querySelector('.shopify-policy__title h1');
    const body = document.querySelector('.shopify-policy__body .rte');
    if (!body || body.dataset.ccfFormatted === 'true') return;

    body.dataset.ccfFormatted = 'true';

    body.querySelectorAll(':scope > p').forEach((paragraph) => {
      const text = paragraph.textContent.trim();

      if (text.startsWith('### ')) {
        const headingText = text.replace(/^###\s+/, '').trim();
        if (title && headingText.toLowerCase() === title.textContent.trim().toLowerCase()) {
          paragraph.remove();
          return;
        }

        const heading = document.createElement('h2');
        heading.textContent = headingText;
        paragraph.replaceWith(heading);
        return;
      }

      const firstStrong = paragraph.querySelector(':scope > strong:first-child');
      if (firstStrong) {
        firstStrong.textContent = firstStrong.textContent.replace(/^\*\*|\*\*$/g, '');
      }

      const rawHeading = paragraph.innerHTML.match(/^\*\*(.+?):\*\*(?:<br\s*\/?>)?/i);
      if (rawHeading) {
        paragraph.innerHTML = paragraph.innerHTML.replace(
          rawHeading[0],
          `<strong>${rawHeading[1]}:</strong><br>`
        );
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatPolicyContent, { once: true });
  } else {
    formatPolicyContent();
  }

  document.addEventListener('shopify:section:load', formatPolicyContent);
})();
